import React, { useState } from "react";
import { Box } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import ComponentSlider from "src/mtska-frontend-app-component/components/Slider/ComponentSlider";
import { useDashboardFiltersStorageKey } from 'src/mtska-frontend-modules/modules/_shared/dashboardFilters/DashboardFiltersStorageKeyContext';
import { Button } from "src/mtska-frontend-app-component";
import JSONPretty from 'react-json-pretty'
import { useSettingContextInComponent, useSyncDashboardFullscreenClass } from "src/mtska-frontend-app-scaffolding";
import { resolveBiIntegratedReport } from 'src/mtska-frontend-modules/modules/BiIntegrated/components/dashboard/reportResolver';
import { useDashboardReportConfiguration } from 'src/mtska-frontend-modules/modules/_shared/dashboardFilters/useDashboardReportConfiguration';
import { getSectionIdsForDashboardModule } from 'src/mtska-frontend-modules/modules/_shared/dashboardFilters/dashboardModuleSectionMap';

const Container = ({ dataProviderName, filters:defaultFilters }) => {
    const { t } = useTranslation();
    useSyncDashboardFullscreenClass();
    const [reportVisible, setReportVisible] = useState(false);
    const { filterModel } = useSettingContextInComponent(useDashboardFiltersStorageKey(dataProviderName), defaultFilters);
    const { reportConfiguration } = useDashboardReportConfiguration();
    const showKPI = true;
    const mergedFilters = filterModel ?? defaultFilters;
    const report = resolveBiIntegratedReport({
        t,
        filters: mergedFilters,
        keyPrefix: 'advertising-cost',
        filtersStorageKey: dataProviderName,
        sectionIds: getSectionIdsForDashboardModule('advertisingCost'),
        reportConfiguration,
    });

    return (
        <Box className="mtska-dashboard-container" sx={{ position: "relative" }}>
            {/* filtri in Container
            <JSONPretty data={filterModel} className="json-wrapper" /> */}
            {showKPI &&
                <Box className="dashboard-section-title" sx={{ marginTop: '30px', marginBottom: '10px' }}>
                    <h2>{t('Costs status')}</h2>
                </Box>
            }

            <Box className="dashboard-report-visibility-wrapper">
                <Button className="dashboard-report-visibility-toggler" onClick={() => setReportVisible(!reportVisible)} variant={'outlined'}>{reportVisible ? t('Hide report') : t('Show report')}</Button>
            </Box>

            {
                reportVisible && <ComponentSlider report={report} />
            }
            <Box className="mtska-fullscreen-toggle">
                <Button
                    variant="soft"
                    size="sm"
                    icon="faExpand"
                    onClick={() => {
                        const parent = document.querySelector('.mtska-dashboard-container');
                        if (!parent) return;
                        if (document.fullscreenElement || document.webkitFullscreenElement) {
                            parent.classList.remove('mtska-fullscreen');
                            if (document.exitFullscreen) {
                                document.exitFullscreen();
                            } else if (document.webkitExitFullscreen) {
                                document.webkitExitFullscreen();
                            }
                        } else {
                            if (parent.requestFullscreen) {
                                parent.requestFullscreen()
                                    .then(() => parent.classList.add('mtska-fullscreen'))
                                    .catch(() => parent.classList.remove('mtska-fullscreen'));
                            } else if (parent.webkitRequestFullscreen) {
                                parent.webkitRequestFullscreen();
                                parent.classList.add('mtska-fullscreen');
                            }
                        }
                    }}
                    aria-label={t('Fullscreen')}
                />
            </Box>
        </Box>
    )
}

export default Container;